<template>
  <div class="content--sinoreg RelacaoRegistros">
    <header-blue>
      Listagem de registros
    </header-blue>

    <div>
      <b-row class="mt-3">
        <b-col cols="4">
          <box-tipo v-model="form.tipo"
                    class="ml-3 "
                    :prop-options="tiposRegistros"
                    :prop-header-blue="true"
                    :prop-tipo-registro="form.tipo" />
        </b-col>
      </b-row>
      <b-row class="ml-3 mr-3">
        <b-col class="RelacaoRegistros--borderBlue">
          <div v-if="form.tipo === 'O'"
               class="mt-3">
            <label><b>Mostrar:</b></label>
            <b-row>
              <b-col cols="1">
                <b-form-checkbox
                  v-model="form.obito"
                  :value="true">
                  <b>Óbito</b>
                </b-form-checkbox>
              </b-col>
              <b-col cols="1">
                <b-form-checkbox
                  v-model="form.natimorto"
                  :value="true">
                  <b>Natimorto</b>
                </b-form-checkbox>
              </b-col>
              <b-col cols="3"
                     class="text-center"
                     style="margin-top: -10px">
                <b-button variant="outline-primary"
                          @click="show.modal = true">
                  Escolher dados a listar
                </b-button>
              </b-col>
              <b-col cols="12"
                     class="my-2">
                <p class="m-0 p-0">
                  Número do registro e nome do registrado sempre serão listados
                </p>
              </b-col>
            </b-row>
          </div>
          <div v-else-if="form.tipo === 'C'"
               class="mt-3">
            <label><b>Mostrar:</b></label>
            <b-row>
              <b-col cols="9"
                     class="d-inline-flex justify-content-between">
                <b-form-checkbox
                  v-model="form.habilitacao"
                  :value="true">
                  <b>Habilitação</b>
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="form.casamento"
                  :value="true">
                  <b>Casamento civil</b>
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="form.casamento_religioso"
                  :value="true">
                  <b>Casamento religioso</b>
                </b-form-checkbox>
                <b-col cols="5"
                       style="margin-top: -10px">
                  <b-button variant="outline-primary"
                            @click="show.modal = true">
                    Escolher dados a listar
                  </b-button>
                </b-col>
              </b-col>
              <b-col cols="12"
                     class="my-2">
                <p class="m-0 p-0">
                  Número do registro e nome dos registrados sempre serão listados
                </p>
              </b-col>
            </b-row>
          </div>
          <div v-else-if="form.tipo === 'N'"
               class="my-2">
            <b-row>
              <b-col cols="3"
                     class="text-center mt-2">
                <b-button variant="outline-primary"
                          block
                          @click="show.modal = true">
                  Escolher dados a listar
                </b-button>
              </b-col>
              <b-col cols="12"
                     class="mt-2">
                <p class="m-0 p-0">
                  Número do registro e nome do registrado sempre serão listados
                </p>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <b-row class="pl-4 pt-2">
        <b-col cols="4">
          <b-form-group label="Data do registro"
                        label-class="font-weight-bold pt-0">
            <b-row no-gutters>
              <b-col cols="5">
                <input v-model="form.data_inicial"
                       type="date"
                       class="form-control form-control-sm">
              </b-col>
              <b-col cols="2">
                <div class="RelacaoRegistros--divider pl-3">
                  até
                </div>
              </b-col>
              <b-col cols="5">
                <input v-model="form.data_final"
                       type="date"
                       class="form-control form-control-sm">
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Ordenar por"
                        label-class="font-weight-bold pt-0">
            <b-row>
              <b-col cols="3">
                <select v-model="form.order"
                        class="form-control form-control-sm">
                  <option value="termo">
                    Número do registro
                  </option>
                  <option value="nome">
                    Nome registrado
                  </option>
                </select>
              </b-col>
              <b-col cols="2"
                     class="">
                <b-button variant="secondary"
                          size="sm"
                          @click="filtrar()">
                  Filtrar
                </b-button>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>
      <hr class="m-1">

      <object v-if="pdf != null"
              class="document-preview embed-responsive"
              :data="`${ pdf }`"
              type="application/pdf">
        <p>Seu browser não suporta arquivos pdf diretamente ou este arquivo não existe. Você pode tentar efetuar o download clicando.</p>
      </object>
    </div>

    <b-modal v-if="show.modal"
             id="modalEscolherOpcoesDinamicas"
             visible
             size="lg"
             hide-header
             hide-footer
             centered
             @hide="show.modal = false">
      <div>
        <h5>Mostrar na listagem:</h5>
      </div>
      <div class="mt-1">
        <b-form-checkbox
          v-model="selecionarTodos"
          :value="true">
          Selecionar todos
        </b-form-checkbox>
      </div>
      <hr class="m-2">
      <div>
        <b-row v-if="form.tipo !== 'C'">
          <b-col v-for="(campo, index) in campos"
                 :key="`campos_dinamico_${ index }`"
                 cols="6 mt-1">
            <b-form-checkbox
              v-if="Array.isArray(campo.array)"
              v-model="camposDinamicos"
              :value="campo.value"
              @change="dynamicManipulation(campo)">
              {{ campo.label }}
            </b-form-checkbox>

            <b-form-checkbox
              v-else
              v-model="camposDinamicos"
              :value="campo.value">
              {{ campo.label }}
            </b-form-checkbox>
          </b-col>
        </b-row>
        <div v-else>
          <b-row>
            <b-col cols="12">
              <label class="p-0 m-0 label"
                     for="">Sobre o registro</label>
              <hr class="mt-1">
            </b-col>
            <b-col v-for="(campo, index) in camposRegistro"
                   :key="`campos_dinamico_${ index }`"
                   cols="6 mt-1">
              <b-form-checkbox
                v-if="Array.isArray(campo.array)"
                v-model="camposDinamicos"
                :value="campo.value"
                @change="dynamicManipulation(campo)">
                {{ campo.label }}
              </b-form-checkbox>

              <b-form-checkbox
                v-else
                v-model="camposDinamicos"
                :value="campo.value">
                {{ campo.label }}
              </b-form-checkbox>
            </b-col>
            <b-col cols="12">
              <label class="p-0 m-0 label mt-2"
                     for="">Sobre o Cônjuge 1
              </label>
              <hr class="mt-1">
            </b-col>
            <b-col v-for="(campo, index) in camposConjugeUm"
                   :key="`campos_dinamico_${ index }`"
                   cols="6 mt-1">
              <b-form-checkbox
                v-if="Array.isArray(campo.array)"
                v-model="camposDinamicos"
                :value="campo.value"
                @change="dynamicManipulation(campo)">
                {{ campo.label }}
              </b-form-checkbox>

              <b-form-checkbox
                v-else
                v-model="camposDinamicos"
                :value="campo.value">
                {{ campo.label }}
              </b-form-checkbox>
            </b-col>
            <b-col cols="12">
              <label class="p-0 m-0 label mt-2"
                     for="">Sobre o Cônjuge 2</label>
              <hr class="mt-1">
            </b-col>
            <b-col v-for="(campo, index) in camposConjugeDois"
                   :key="`campos_dinamico_${ index }`"
                   cols="6 mt-1">
              <b-form-checkbox
                v-if="Array.isArray(campo.array)"
                v-model="camposDinamicos"
                :value="campo.value"
                @change="dynamicManipulation(campo)">
                {{ campo.label }}
              </b-form-checkbox>

              <b-form-checkbox
                v-else
                v-model="camposDinamicos"
                :value="campo.value">
                {{ campo.label }}
              </b-form-checkbox>
            </b-col>
          </b-row>
        </div>
        <b-row class="mt-3">
          <b-col>
            <div class="text-right">
              <b-button size="sm"
                        variant="default"
                        @click="show.modal = false">
                Voltar
              </b-button>
              <b-button size="sm"
                        class="ml-1"
                        variant="secondary"
                        @click="salvarCampos()">
                Continuar
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
  /* components */
  import HeaderBlue from "@/components/SofiaRei/Headers/HeaderBlue"
  import BoxTipo from "@/components/SofiaRei/BoxTipo"

  /* constants */
  import { obito, nascimento, casamento } from "@/constants/relatorios/campos"

  /* icons */
  import icon_casamento from "@/assets/icons/engagement.svg?sprite"
  import icon_nasc from "@/assets/icons/baby-buggy.svg?sprite"
  import icon_obito from "@/assets/icons/flower.svg?sprite"

  /* services */
  import ListagemRegistrosService from "@/services/Relatorios/ListagemRegistrosService"

  export default {
    name: "ListagemRegistros",
    components: {
      HeaderBlue,
      BoxTipo
    },
    data () {
      return {
        obito,
        nascimento,
        casamento,
        tiposRegistros: [
          {
            text: "Nascimento",
            id: 1,
            valor: "N",
            icon: icon_nasc,
          },
          {
            text: "Casamento",
            id: 2,
            valor: "C",
            icon: icon_casamento,
          },
          {
            text: "Óbito",
            id: 3,
            valor: "O",
            icon: icon_obito
          },
        ],
        form: {
          tipo: 'N',
          data_inicial: null,
          data_final: null,
          obito: true,
          natimorto: false,
          habilitacao: true,
          casamento: false,
          casamento_religioso: false,
          order: 'termo'
        },
        show: {
          modal: false
        },
        selecionarTodos: false,
        camposDinamicos: ['livro'],
        pdf: null,
        tiposFiltros: {
          'N': 'NASCIMENTO',
          'O': 'OBITO',
          'C': 'CASAMENTO'
        }
      }
    },
    computed: {
      campos () {
        switch (this.form.tipo) {
        case 'O':
          return obito
        case 'N':
          return nascimento
        case 'C':
          return casamento
        default:
          return obito
        }
      },
      camposRegistro () {
        return this.campos.filter(campo => !campo.label.match('Cônjuge 1') && !campo.label.match('Cônjuge 2'))
      },
      camposConjugeUm () {
        return this.campos.filter(campo => campo.label.match('Cônjuge 1'))
      },
      camposConjugeDois () {
        return this.campos.filter(campo => campo.label.match('Cônjuge 2'))
      }
    },
    watch: {
      selecionarTodos () {
        this.campos.forEach(campo => {
          if (this.selecionarTodos) {
            if (!!campo.array) {
              this.camposDinamicos.push(...campo.array)
            } else {
              this.camposDinamicos.push(campo.value)
            }

            // deixando values unicos
            this.camposDinamicos = [...new Set([...this.camposDinamicos])]
          } else {
            this.camposDinamicos = []
          }
        })
      },
      'form.tipo' () {
        this.init()
      }
    },
    created () {
      this.init()
    },
    methods: {
      async init () {
        loader({ active: true })

        try {
          const tipo =  this.tiposFiltros[this.form.tipo]
          const config = await ListagemRegistrosService.getConfig({ chave: `FILTRO_REGISTRO_LISTAGEM_${tipo}` })

          if (config) {
            this.camposDinamicos = JSON.parse(config.valor).filtros

            // removemos os filtros genericos criados
            this.camposDinamicos = this.camposDinamicos.filter(campo => campo !== 'nome_registrado' && campo !== 'termo')
          } else {
            this.camposDinamicos = []

            // criamos os filtros caso eles n existam para evitar erro
            const payload = {
              filtros: ['nome_registrado', 'termo'],
              tipo_registro: this.form.tipo
            }

            await ListagemRegistrosService.saveCampos(payload)
          }
        } catch (error) {
          const {response: { data }} = error

          const message = data && data.message ? data.message : 'Não foi possível carregar as configurações.'

          displayMessage('error', 'Erro!', message)
        }

        loader({ active: false })
      },
      async salvarCampos () {
        if (this.camposDinamicos.length > 0) {
          try {
            loader({ active: true })
            const payload = {
              filtros: this.camposDinamicos,
              tipo_registro: this.form.tipo
            }

            await ListagemRegistrosService.saveCampos(payload)
            this.show.modal = false
            displayMessage('success', 'Campos salvos com sucesso!')
          } finally {
            loader({ active: false })
          }
        } else {
          displayMessage('error', 'Erro!', 'Selecione algum campo para prosseguir.')
        }
      },
      dynamicManipulation (campo) {
        // adiciona ou remove o valor
        const addRemove = (valor) => {
          const index = this.camposDinamicos.indexOf(valor)
          if (index === -1) {
            this.camposDinamicos.push(valor)
          } else {
            this.camposDinamicos.splice(index, 1)
          }
        }

        // metodo para quando o valor for Array
        // irá remover e adicionar
        if (Array.isArray(campo.array)) {
          campo.array.forEach(val => {
            // caso n tenha será adicionado
            addRemove(val)
          })
        } else {
          addRemove(campo.array)
        }
      },
      async filtrar () {
        // metodo que trará o PDF
        const payload = {
          tipo_registro: [],
          data_inicial: this.form.data_inicial,
          data_final: this.form.data_final,
          order: this.form.order
        }

        if (this.form.obito && this.form.tipo == 'O' && payload.tipo_registro.indexOf('O') == -1) {
          payload.tipo_registro.push('O')
        }

        if (this.form.natimorto && this.form.tipo == 'O' && payload.tipo_registro.indexOf('NT') == -1) {
          payload.tipo_registro.push('NT')
        }

        if (this.form.habilitacao && this.form.tipo == 'C' && payload.tipo_registro.indexOf('D') == -1) {
          payload.tipo_registro.push('D')
        }

        if (this.form.casamento && this.form.tipo == 'C' && payload.tipo_registro.indexOf('C') == -1) {
          payload.tipo_registro.push('C')
        }

        if (this.form.casamento_religioso && this.form.tipo == 'C' && payload.tipo_registro.indexOf('CR') == -1) {
          payload.tipo_registro.push('CR')
        }

        if (!payload.tipo_registro.length) payload.tipo_registro.push(this.form.tipo)

        try {
          loader({ active: true })
          this.pdf = await ListagemRegistrosService.getPdf(payload)
        } finally {
          loader({ active: false })
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .RelacaoRegistros {
    &--borderBlue {
      border: 2px solid #18507f;
    }

    &--divider{
      width: 20px !important;
    }
  }

  .document-preview {
    height: 500px !important;
  }
</style>
